(() => {
  if (customElements.get('mc-release')) return;
  const active = new Set();
  let interval;
  const pad = value => String(value).padStart(2, '0');
  const tick = () => {
    const now = Date.now();
    for (const element of active) {
      if (!element.isConnected) { active.delete(element); continue; }
      const remaining = Math.max(0, Math.ceil((element.releaseAt - now) / 1000));
      if (!remaining) {
        element.removeAttribute('data-active');
        element.querySelector('.mc-release__upcoming').hidden = true;
        const normal = element.querySelector('.mc-release__normal');
        normal.hidden = false;
        if (!normal.innerHTML.trim()) element.hidden = true;
        active.delete(element);
        continue;
      }
      const countdown = element.querySelector('.mc-release__countdown');
      if (countdown) {
        countdown.textContent = pad(Math.floor(remaining / 86400)) + 'D : ' +
          pad(Math.floor(remaining / 3600) % 24) + 'H : ' +
          pad(Math.floor(remaining / 60) % 60) + 'M : ' + pad(remaining % 60) + 'S';
        countdown.hidden = false;
      }
    }
    if (!active.size && interval) { clearInterval(interval); interval = undefined; }
  };
  const dateFormat = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', month: 'short', day: '2-digit' });
  const timeFormat = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit', hour12: true });
  customElements.define('mc-release', class extends HTMLElement {
    connectedCallback() {
      this.releaseAt = Date.parse(this.dataset.releaseAt);
      if (!Number.isFinite(this.releaseAt)) return;
      const time = this.querySelector('time');
      const date = dateFormat.format(this.releaseAt).toUpperCase();
      const hour = timeFormat.format(this.releaseAt).replace(':00', '').replace(/\s/g, '').toUpperCase();
      if (time) time.textContent = this.dataset.label.replace('RELEASE_DATE', date).replace('RELEASE_TIME', hour);
      active.add(this);
      tick();
      if (active.size && !interval) interval = setInterval(tick, 1000);
    }
    disconnectedCallback() {
      active.delete(this);
      if (!active.size && interval) { clearInterval(interval); interval = undefined; }
    }
  });
  document.addEventListener('visibilitychange', tick);
  window.addEventListener('pageshow', tick);
})();
